module.exports = __webpack_public_path__ + "static/media/32.77dbd2ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/32.png
// module id = 815
// module chunks = 0